import React, { Component } from 'react';
import { SectionWrapper, Header } from './components';

class Section extends Component {
	render() {
		return (
			<SectionWrapper>
				<a className="anchor" name={this.props.anchor} />
				<Header>{this.props.title}</Header>
				{this.props.content}
			</SectionWrapper>
		);
	}
}

export default Section;


// WEBPACK FOOTER //
// ./src/components/section/index.js